import Alpine from 'alpinejs';
import api, { requireAuth } from './api.js';

function createInkoCreationProjects() {
  return {
    loading: true,
    projects: [],

    async init() {
      if (!requireAuth()) return;
      try {
        const { items } = await api.listProjects();
        this.projects = items;
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat proyek.', 'error');
      } finally {
        this.loading = false;
      }
    },
  };
}

Alpine.data('inkoCreationProjects', createInkoCreationProjects);
